'use strict';

/* globals $, window, document, socket, ajaxify */

function loadVideos(elSelector) {
	$(elSelector)
		.delay(500)
		.customVideo(ajaxify.data.template.name);
}

$(document).ready(function () {
	socket.on('event:video_compressed', function (data) {
		loadVideos('.video-compressing[data-video-id="' + data.videoId + '"]');
	});
});

$(window).on('action:posts.loaded', function () {
	loadVideos('.custom-video');
});

$(window).on('action:ajaxify.end', function () {
	loadVideos('.custom-video');
});